import React from "react";
import { Helmet } from "react-helmet-async";

// SEO-optimized page titles and descriptions for Las Vegas permanent makeup
export const SEO_DATA = {
    home: {
        title: "Beauty Ink LV | #1 Permanent Makeup Las Vegas | Nano Brows & Lip Blush",
        description: "Las Vegas' top-rated permanent makeup studio. Nano brows, lip blushing, combo brows & eyeliner tattoo by Wendy Chester, PMUA. 30+ 5-star reviews. Se habla español. Book today!",
    },
    nanoBrows: {
        title: "Nano Brows Las Vegas | Natural Hair-Stroke Eyebrow Tattoo Near Me",
        description: "Get ultra-natural nano brows in Las Vegas. Machine hair-stroke technique perfect for oily & mature skin. 5-star rated. Bilingual artist Wendy Chester. Free consultation!",
    },
    powderBrows: {
        title: "Powder Brows Las Vegas | Ombré Eyebrow Tattoo | Wake Up Flawless",
        description: "Soft, makeup-style powder brows in Las Vegas. Beautifully filled-in ombré brows that last 2-3 years. Pricing in consultation. 5 min from LAS airport. Se habla español.",
    },
    comboBrows: {
        title: "Combo Brows Las Vegas | Nano + Powder Brows Together | Best Results",
        description: "Combo brows = best of both worlds. Hair strokes + powder shading for the most natural, full brow. Las Vegas' top PMU studio. Book your consultation today!",
    },
    lipBlushing: {
        title: "Lip Blushing Las Vegas | Natural Permanent Lip Color & Tint Near Me",
        description: "Lip blushing in Las Vegas by Wendy Chester, PMUA. Subtle, natural lip tint that restores color & definition. Heals beautifully. 30+ 5-star reviews. Se habla español.",
    },
    microblading: {
        title: "Microblading Las Vegas | Hand-Drawn Eyebrow Tattoo | Beauty Ink LV",
        description: "Expert microblading in Las Vegas. Traditional hand-drawn hair strokes for natural brows. Best for dry-normal skin. Consultation required. Bilingual studio.",
    },
    eyelinerTattoo: {
        title: "Permanent Eyeliner Las Vegas | Lash Line & Winged Eyeliner Tattoo",
        description: "Smudge-proof permanent eyeliner in Las Vegas. Lash line enhancement or winged eyeliner by Wendy Chester. Waterproof definition that lasts. Book consultation!",
    },
    browLamination: {
        title: "Brow Lamination Las Vegas | Fluffy Brow Perm & Tint | $$ Affordable",
        description: "Brow lamination perm + tint in Las Vegas. Fluffy, brushed-up brows lasting 6-8 weeks. Non-permanent treatment near LAS airport. Walk out with perfect brows!",
    },
    lashes: {
        title: "Lash Lift Las Vegas | Natural Lash Curl & Tint | No Extensions Needed",
        description: "Lash lift & tint in Las Vegas. Wake up with curled, defined lashes — no extensions or daily mascara. Lasts 6-8 weeks. Beauty Ink LV near airport. Book today!",
    },
    tattoos: {
        title: "Fine Line Tattoos Las Vegas | Tiny & Delicate Tattoos | Elisha Lee",
        description: "Delicate fine line & tiny tattoos in Las Vegas by artist Elisha Lee at Beauty Ink LV. Minimalist body art near the Strip & airport. First-timers welcome!",
    },
    aftercare: {
        title: "Permanent Makeup Aftercare Guide | Healing Tips | Beauty Ink LV",
        description: "Step-by-step aftercare for nano brows, lip blushing, microblading & eyeliner tattoo. Expert healing guide from Beauty Ink LV Las Vegas. Get beautiful results!",
    },
    bedRentals: {
        title: "PMU Studio Bed Rental Las Vegas | $50/Half-Day | Licensed Space",
        description: "Rent a fully-equipped PMU bed in Las Vegas. $50 half-day, $75 full-day, $200/week cap. Clean, licensed studio near airport. Perfect for traveling PMU artists!",
    },
    training: {
        title: "Permanent Makeup Training Las Vegas | 6-Month Mentorship | Earn $100K+",
        description: "Become a PMU artist. 6-month apprenticeship in Las Vegas with Wendy Chester. Learn nano brows, lip blushing & business skills. Limited spots — apply now!",
    },
    about: {
        title: "Meet Wendy Chester | Las Vegas PMU Artist | 10+ Years Experience",
        description: "Wendy Chester — founder of Beauty Ink LV, licensed PMUA & Advanced Esthetician. 10+ years crafting natural nano brows, lip blush & more. Bilingual. 30+ 5-star reviews.",
    },
    contact: {
        title: "Contact Beauty Ink LV | Visit Our Las Vegas Studio | (702) 919-9565",
        description: "Visit Beauty Ink LV at 5030 Paradise Rd, Unit C109, Las Vegas. 5 min from airport. Call (702) 919-9565 or send a message. Se habla español. Open Tue-Sat.",
    },
    services: {
        title: "All Permanent Makeup Services Las Vegas | Beauty Ink LV by Wendy Chester",
        description: "Explore all services: nano brows, combo brows, powder brows, lip blushing, eyeliner tattoo, brow lamination, lash lifts & fine line tattoos. Las Vegas' top PMU studio.",
    },
};

const SEOHead = ({ page, customTitle, customDescription }) => {
    const seo = SEO_DATA[page] || SEO_DATA.home;
    const title = customTitle || seo.title;
    const description = customDescription || seo.description;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
};

export default SEOHead;
